import * as React from "react";
import { cn } from "@/lib/utils";

interface ProgressProps {
  value: number; // 0-100
  className?: string;
  barClassName?: string;
  showLabel?: boolean;
  label?: string;
}

const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  (
    { value, className, barClassName, showLabel = false, label, ...props },
    ref,
  ) => {
    const clampedValue = Math.min(Math.max(value, 0), 100);

    return (
      <div
        ref={ref}
        className={cn(
          "relative w-full overflow-hidden rounded-full",
          className,
        )}
        style={{ backgroundColor: "#e5e7eb" }}
        {...props}
      >
        <div
          className={cn(
            "h-full rounded-full transition-all duration-300 ease-out bg-[#1f2937]",
            barClassName,
          )}
          style={{ width: `${clampedValue}%` }}
        />
        {showLabel && label && (
          <span className="absolute inset-0 flex items-center justify-center text-xs text-gray-600">
            {label}
          </span>
        )}
      </div>
    );
  },
);
Progress.displayName = "Progress";

export { Progress };
